<template>
  <div class="overall-bg p-0">
    <b-container>
      <b-row class="tabviewtable">
        <b-col>
          <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
            <div class="">
              <div class="filter_chip" v-if="filterItemsArray[0]['Date'] != ''">
                <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
                <span @click="removeChip('Date')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['Code'] != ''">
                <span>Quote code: {{ filterItemsArray[0]["Code"] }}</span>
                <span @click="removeChip('Code')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['PoCode'] != ''">
                <span>Quote code: {{ filterItemsArray[0]["PoCode"] }}</span>
                <span @click="removeChip('PoCode')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['SupplierName'] != ''">
                <span>Supplier Name:
                  {{ filterItemsArray[0]["SupplierName"] }}</span>
                <span @click="removeChip('SupplierName')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['FromStore'] != ''">
                <span>From Store: {{ filterItemsArray[0]["FromStore"] }}</span>
                <span @click="removeChip('FromStore')"><i class="pi pi-times"></i>
                </span>
              </div>

              <div class="filter_chip" v-if="filterItemsArray[0]['StatusName'] != ''">
                <span>Status: {{ filterItemsArray[0]["StatusName"] }}</span>
                <span @click="removeChip('StatusName')"><i class="pi pi-times"></i>
                </span>
              </div>
            </div>
            <div class="">
              <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
                Clear all
              </button>
            </div>
          </div>
          <div class="form-white-bg" v-if="windowWidth > 545">
            <b-row>
              <b-col :lg="visible ? '3' : '0'" v-if="items.length !== 0">
                <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                  <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                    :ClearDateFilter="SearchValue" v-if="FilterLoading">
                    <template v-slot:filterslot>
                      <!-- <poGrnFilters :showFields="false" @StatusNames="EmitStatus" @StatusIds="EmitStatusId"
                        :removechiptype="removechipvalue" :StatusFilter="StatusFilter" /> -->
                    </template>
                  </FilterForm>
                </b-collapse>
              </b-col>
              <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                  <MasterEmpty v-if="items.length === 0 &&
                    !SearchValue.inputValue &&
                    !SearchValue.fromDate &&
                    !SearchValue.toDate &&
                    !hasData
                  " eheader="Quote" econtent="Quote" eimg="/src/assets/Img/icons/itemmaster.svg"
                    @createNew="IsCreate()" />
                  <Tableview :value="items" v-if="items.length !== 0 ||
                    SearchValue.inputValue ||
                    SearchValue.fromDate ||
                    SearchValue.toDate ||
                    hasData
                  " class="p-datatable-gridlines commonstatusclass" :rows="10" dataKey="id" :rowHover="true"
                    @row-click="RowClick" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                    :columns="headers" :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows"
                    :globalFilterFields="globalFilterFields" :filters="filters" :searchbox="false" :searchbox1="true"
                    @search="SearchBox" :exceldownload="true" :filterbtn="true" :statusFilterBtn="true">
                    <template v-slot:exceldownload>
                      <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                        :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                    </template>
                    <template v-slot:Add v-if="!QueryStringValue4?.PIId">
                      <span class="add">
                        <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')">
                        </AddButton>
                      </span>
                    </template>
                    <template v-slot:statusFilterBtn>
                      <div class="filterBtnStatus d-flex align-items-center">
                        <div class="filter_chip1" :class="{
                          'selected-chip': item.id === selectedStatus,
                        }" v-for="item in filterStatus" :key="item.id" @click="selectStatus(item.id, item.name)">
                          <p>
                            {{ item.name }}
                          </p>
                        </div>
                      </div>
                    </template>
                    <template v-slot:filter>
                      <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                        :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                        @click="visible = !visible"></i>
                    </template>

                    <template v-slot:waitingsince="{ data }">
                      <p>
                        {{
                          data.Status == "0" ? waitingtime(data.DocDateHR) : "-"
                        }}
                      </p>
                    </template>

                    <template v-slot:status="{ data }">
                      <!-- {{ data.IsDraft}} -->
                      <RedStatus name="Draft" v-if="data.IsDraft == '1'" />
                      <OrangeStatus name="Pending" v-if="data.IsDraft != '1' && data.Status == '0'" />
                      <RedStatus name="Cancel Quote Amendment" v-if="data.Status == '5'" />
                      <RedStatus name="Cancel Quote" v-if="data.Status == '4'" />
                      <!-- <BlueStatus name="Converted To Quote Amendment" v-if="data.Status == '1'" /> -->
                      <!-- <BlueStatus name="Converted To GRN" v-if="data.Status == '2'" /> -->
                      <RedStatus name="Closed" v-if="data.Status == '6'" />
                      <div v-if="data.Status == '6'">
                        <span for="">Reason: {{ data?.ClosedReason }}</span>
                      </div>
                    </template>

                    <template v-slot:ApprovalStatus="{ data }">
                      <OrangeStatus name="Pending" v-if="data.IsApproved == '0'" />
                      <GreenStatus name="Approved" v-if="data.IsApproved == '1'" />
                      <RedStatus name="Declined" v-if="data.IsApproved == '3'" />
                    </template>

                    <template v-slot:action="{ data }">
                      <span>
                        <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                          @click="toggle($event, data)" />
                      </span>
                    </template>
                  </Tableview>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="items in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="items.length === 0 &&
                !SearchValue.inputValue &&
                !SearchValue.fromDate &&
                !SearchValue.toDate
              " eheader="Quote" econtent="Quote" eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsCreate()"
                :createline="false" />
              <MobileViewCardHeader :totalRecords="rowsCount" :state="state" @search="SearchBox" v-if="items.length !== 0 ||
                SearchValue.inputValue ||
                SearchValue.fromDate ||
                SearchValue.toDate
              ">
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items" @click="RowClick(item)">
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <p class="light-name">
                          {{ item["DocNo"] }} / {{ item["DocNo"] }}
                        </p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <div>
                          <OrangeStatus name="Pending" v-if="item['Status'] == '0'" />
                          <RedStatus name="Cancel Quote Amendment" v-if="item['Status'] == '5'" />
                          <RedStatus name="Cancel Quote" v-if="item['Status'] == '4'" />
                          <BlueStatus name="Converted To Quote Amendment" v-if="item['Status'] == '1'" />
                          <!-- <BlueStatus name="Converted To GRN" v-if="item['Status'] == '2'" /> -->
                          <RedStatus name="Closed" v-if="item['Status'] == '6'" />
                          <div v-if="item['Status'] == '6'">
                            <span for="">Reason: {{ item["ClosedReason"] }}</span>
                          </div>
                        </div>
                        <i class="pi pi-ellipsis-v" @click="toggle($event, item)" v-if="item['Status'] == '0'"></i>
                      </div>
                    </div>
                    <p class="name mt-0">{{ item["SupplierName"] }}</p>
                    <p class="light-name">
                      <i class="pi pi-calendar me-2">:</i><span class="small-name">{{
                        item["DocDate"] }}</span>
                    </p>
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <p class="light-name">
                        Items :
                        <span class="small-name">{{ item["ItemCount"] }}</span>
                      </p>
                      <p class="light-name">
                        Items Value :
                        <span class="small-name">{{ item["Amount"] }}</span>
                      </p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <Dialog v-model:visible="ObjPOClosePopUp.Visible" modal :header="ObjPOClosePopUp.PopUpHeaderName" :breakpoints="{
    '1980px': '55vw',
    '1440px': '60vw',
    '960px': '70vw',
    '640px': '90vw',
  }" class="overall-bg">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <Textarea :name="ObjPOClosePopUp.TextAareaName" :label="ObjPOClosePopUp.TextAareaName"
              :rules="{ required: false }" :id="ObjPOClosePopUp.TextAareaName" v-model="ObjPOClosePopUp.ClosedReason" />
            <Footer class="p-3" @cancel="ObjPOClosePopUp.Visible = false" @save="SaveClosePO" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete()" @no="Deletemodel = false" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />

  <ClosedSuccessfully :content="ModelPopupDunction.CloseModelTxt" :visible="ModelPopupDunction.CloseSuccessPop"
    @ok="Close()" />

  <CloseConfirmation :Editmodel="ModelPopupDunction.CloseConfirmPop" @yes="UpdateCloseStatus()"
    @no="ModelPopupDunction.CloseConfirmPop = false" :header="ObjPOClosePopUp.ConfirmPopupHeader"
    :content="ObjPOClosePopUp.ConfirmPopupContent" />

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />

  <QuotesDetailsRightSidebar v-model:visible="visibleRight" position="right" @close="visibleRight = false" />
  <QuotesDetails v-model:visible="VisibleQuotesDetails" position="right" @close="VisibleQuotesDetails = false" />

  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  onMounted,
  watch,
  reactive,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";

import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";


import service from "../../../../Service/SupplierMaster";
import Table from "../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../../Service/WithoutStockAffectService";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from  "../../../../../../modules/Inventory/Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import poGrnFilters from  "../../../../../../modules/Inventory/components/Filters/poGrnFilters.vue";
import moment from "moment";
import FilterForm from "../../../../../../components/FormComponents/FilterForm.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
import CrystalReportPrintPopUp from  "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

import CloseConfirmation from "../../../../../../components/FormComponents/CancelConfirmation.vue";
import ClosedSuccessfully from "../../../../../../components/FormComponents/CancelSuccessfully.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import QuotesDetailsRightSidebar from  "../../../../../../modules/Inventory/components/Sidebar/RightSidebar/QuotesDetailsRightSidebar.vue";
import QuotesDetails from  "../../../../../../modules/Inventory/components/Sidebar/RightSidebar/component/QuotesDetails.vue";

export default defineComponent({
  components: {
    QuotesDetailsRightSidebar,
    QuotesDetails,
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    BacktoPage,
    Headerlayout,


    Table,
    Tableview,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    poGrnFilters,
    FilterForm,
    ExportOption,
    CrystalReportPrintPopUp,

    ClosedSuccessfully,
    CloseConfirmation,
    Footer,
  },
  props: {
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
  },
  setup(props) {
    const routes = useRoute();
    let visible = ref(false);
    //let StorebranchmapId = 0;
    // route.query.storebranchmapid ??
    let StorebranchmapId = routes.query.storebranchmapid ?? 0;
    const { t } = useI18n();

    let DataEdit = ref();
    const toast = useToast();
    const visibleRight = ref(false);
    const VisibleQuotesDetails = ref(false);
    let dataId = routes.query.Id ?? 0;
    let columnnametype = routes.query.Type ?? "";
    let status = routes.query.status ?? 0;

    let loading = ref(false);
    const ItemStockTransId = ref(0);

    const menu = ref();
    let objectdata = ref({});
    const IsPending = ref(false);

    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });
    let ParamValues = ref({
      StockWoTransTMId: 0,
      StoreId: 0,
      DocNo: "",
      DocType: 0,
      status: 0,
      type: 0,
      OperationId: ObjOperationId.value.CreateId,
      StoreBrMapId: 0,
      BranchId: 0,
      EntityId: ObjOperationId.value.EntityId,
      IsDraft: 1
      //Type: "",
    });

    ParamValues.value.StoreId = Number(routes.query.Id);
    ParamValues.value.StoreBrMapId = Number(routes.query.storebranchmapid);
    ParamValues.value.BranchId = Number(routes.query.BranchId ?? 0)

    ParamValues.value.status = Number(routes.query.status);
    const router = useRouter();
    const generic = ref();
    let items = ref([]);
    let loading1 = ref(false);
    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    const rowsCount = ref(0);

    let ExportList = ref([]);
    let PageName = ref("Quote");
    let ExportOption = ref("");
    const Activevisible = ref(false);
    const CrystalReportPopup = ref(false);
    const QuoteId = ref(0);
    const ParameterValues = ref({
      Id: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 56,
      HeaderTitle: "Quote",
      ModuleId: 3,
    });

    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    let StatusFilter = ref({
      StatusFrom: "POA",
      Status: true,
    });

    let ObjPOClosePopUp = ref({
      Visible: false,
      ClosedReason: "",
      PopUpHeaderName: "",
      TextAareaName: "",
      ConfirmPopupHeader: "",
      ConfirmPopupContent: "",
    });

    const ObjPOClose = ref({
      Id: 0,
      Status: "0",
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      CreatedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      ClosedReason: "",
      IsApproved: 0,
      StoreId: 0,
      DocNo: ""
    });

    const ModelPopupDunction = ref({
      CloseConfirmPop: false,
      CloseModelTxt: "",
      CloseSuccessPop: false,
    });

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    watch(props, (newValue: any) => {
      debugger;
      console.log("props Changed", newValue.FunctionRights);
      Rights.value.Create = newValue.FunctionRights.Create;
      Rights.value.Update = newValue.FunctionRights.Update;
      Rights.value.Read = newValue.FunctionRights.Read;
      Rights.value.Delete = newValue.FunctionRights.Delete;
      Object.keys(ObjOperationId.value).forEach((key) => {
        if (newValue.FunctionRights[key])
          ObjOperationId.value[key] = newValue.FunctionRights[key];
      });
    }, { deep: true });

    const ColumnVisible = ref(true);
    let QueryStringValue4: any = routes.query;
    if (QueryStringValue4["Type1"] == "PIId") {
      ColumnVisible.value = true;
    } else if (QueryStringValue4["Type"] == "StoreId") {
      ColumnVisible.value = false;
    } else {
      console.log(QueryStringValue4["Type1"]);
    }

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      DocDate: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      SupplierName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ItemCount: { value: null, matchMode: FilterMatchMode.IN, options: items },
      Amount: { value: null, matchMode: FilterMatchMode.IN, options: items },
      POStatusName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const headers = [
      {
        header: t("storetabdetails.quotes.sno"),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },

      {
        field: "POStatusName",
        fieldDisplay: "false",
        header: t("storetabdetails.quotes.Status"),
        slot: "status",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.quotes.BranchName"),
        field: "BranchName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.quotes.Code"),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.quotes.PICode"),
        field: "RefNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.quotes.Supplier"),
        field: "SupplierName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.quotes.ItemCount"),
        field: "ItemCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.quotes.ItemValue"),
        field: "Amount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.quotes.ApprovalStatus"),
        field: "",
        fieldDisplay: "false",
        slot: "ApprovalStatus",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        hide: ColumnVisible.value,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];
    const globalFilterFields = ref(headers.map((col) => col.field));

    const IsCreate = () => {
      // router.push({ name: "Quotes", query: { doctype: "4", param: "Quote" } });
      let permissionResult: any = checkPermission(Rights, "Add");

      if (permissionResult.hasPermission) {
        ParamValues.value.DocType = 3;
        (ParamValues.value.OperationId = ObjOperationId.value.CreateId),
          (ParamValues.value.EntityId = ObjOperationId.value.EntityId);
        router.push({
          path: "/Quotes",
          query: {
            data: JSON.stringify(ParamValues.value),
            param: "Quotes",
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    watch(props, (newValue) => {
      debugger;
      let dataValue: any = {};
      Object.assign(dataValue, newValue.propsParams);
      StorebranchmapId = routes.query.storebranchmapid ?? 0;

      if (dataValue.Id) {
        items.value = [];
        dataId = dataValue.Id;
        status = dataValue.Type;
        IsShow();
      }
    });

    function datapass() {
      debugger;
      ParamValues.value.DocType = 16;
      ParamValues.value.type = 1;
      ParamValues.value.StockWoTransTMId = QuoteId.value;
      (ParamValues.value.OperationId = 3063001), (ParamValues.value.EntityId = 3063);
      router.push({
        path: "/Quotes",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: "QuoteAmendment",
        },
      });

    }

    function IsEdit() {
      debugger;
      // alert(JSON.stringify(DataEdit.value.StockTransId))
      ParamValues.value.DocNo = DataEdit.value["DocNo"];
      ParamValues.value.StockWoTransTMId = DataEdit.value["StockTransId"];
      ParamValues.value.IsDraft = DataEdit.value["IsDraft"];
      (ParamValues.value.OperationId = ObjOperationId.value.CreateId),
        (ParamValues.value.EntityId = ObjOperationId.value.EntityId);
      router.push({
        path: "/Quotes",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: "Quotes",
        },
      });

    }

    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      StorebranchmapId = routes.query.storebranchmapid ?? 0;

      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        StorebranchmapId = routes.query.storebranchmapid ?? 0;

        IsShow();
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        StorebranchmapId = routes.query.storebranchmapid ?? 0;

        await IsShow();
      }
    );
    const hasData = ref(false);
    function SearchBox(value) {
      SearchValue.value.inputValue = value;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }

    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;
        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = columnnametype;
        const columnValue = dataId;
        const columnName1 = filterItems.value.SupplierId ? "SupplierId" : "";
        const columnValue1 = filterItems.value.SupplierId
          ? filterItems.value.SupplierId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = filterItems.value.PoCode ? "RefNo" : "";
        // let columnName3 = filterItems.value.PoCode != "" ? "sm.RefNo =  '" + filterItems.value.PoCode + "'" : "";
        const columnValue3 = filterItems.value.PoCode
          ? filterItems.value.PoCode
          : "";
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          " and (COALESCE('" + usersData.BranchId + "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" + usersData.BranchId + "', ',')))" +
          "";

        if (filterItems.value.StatusIds != "") {
          Condition =
            Condition +
            " and (sm.Status IN(" +
            filterItems.value.StatusIds +
            ")) " +
            "and sm.Status !=(3)";
        } else if (
          buttonFilter.value.Name != "" &&
          buttonFilter.value.Name != "All"
        ) {
          Condition =
            Condition +
            " and (sm.Status IN(" +
            buttonFilter.value.Id +
            ")) " +
            "and sm.Status !=(3)";
        } else if (filterItems.value.StatusIds == "") {
          Condition =
            "sm.HospitalId=" +
            usersData.OrganizationId +
            " and (COALESCE('" + usersData.BranchId + "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" + usersData.BranchId + "', ',')))" +
            "" +
            "and sm.Status not in (3)";
        }
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTM(

          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          3,
          // "3,16",

          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );
        response["result"] = response["result"].filter(
          (x) =>
            x.HospitalId == usersData.OrganizationId
          // x.BranchId == usersData.BranchId
        );
        // alert(JSON.stringify(response["result"]))
        items.value = response["result"].map((item) => {
          item.Amount = Number(item.Amount).toFixed(2);
          return item;
        });;
        if (items.value.length !== 0) {
          hasData.value = true;
        }
        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const pageNum = state.currentPage;
        const pageSize = 0;
        const columnName = columnnametype;
        const columnValue = dataId;
        const columnName1 = filterItems.value.SupplierId ? "SupplierId" : "";
        const columnValue1 = filterItems.value.SupplierId
          ? filterItems.value.SupplierId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = filterItems.value.PoCode ? "RefNo" : "";
        const columnValue3 = filterItems.value.PoCode
          ? filterItems.value.PoCode
          : "";

        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          " and (COALESCE('" + usersData.BranchId + "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" + usersData.BranchId + "', ',')))" +
          "";

        if (filterItems.value.StatusIds != "") {
          Condition =
            Condition +
            " and (sm.Status IN(" +
            filterItems.value.StatusIds +
            ")) ";
        } else if (
          buttonFilter.value.Name != "" &&
          buttonFilter.value.Name != "All"
        ) {
          Condition =
            Condition +
            " and (sm.Status IN(" +
            buttonFilter.value.Id +
            ")) " +
            "and sm.Status !=(3)";
        } else if (filterItems.value.StatusIds == "") {
          Condition =
            "sm.HospitalId=" +
            usersData.OrganizationId +
            " and (COALESCE('" + usersData.BranchId + "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" + usersData.BranchId + "', ',')))" +
            "and sm.Status!=3";
        }
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          "6,13",
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );


        response["result"] = response["result"].map((item) => {
          item.Amount = Number(item.Amount).toFixed(2);
          return item;
        }).filter(
          (x) =>
            x.HospitalId == usersData.OrganizationId
          // x.BranchId == usersData.BranchId
        );

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    //Delete Values in Table
    const IsDelete = async () => {
      try {
        const response = await commonService.DeleteStockWOTM(POAId);
        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          StorebranchmapId = routes.query.storebranchmapid ?? 0;

          IsShow();
          Deletemodel.value = false;
          deletepop.value = true;
        }
      } catch (error) {
        console.log(error);
      }
    };
    const deletepop = ref(false);
    const Deletemodel = ref(false);
    const Editmodel = ref(false);
    const rowFocus = ref(false);
    let POAId = 0;
    let DocType;
    const ObjData = ref();
    const LineDoctype = ref(0);
    // function RowClick(event: any) {
    //   debugger;
    //   rowFocus.value = true;
    //   router.push({
    //     path: "/PODetails",
    //     query: {
    //       formId: 1026,
    //       param: "POAmendment",
    //       doctype: 6,
    //       Id: event.data ? event.data.StockTransId : event.StockTransId,
    //       StoreId: dataId,
    //       status: status,
    //       Postatus: event.data ? event.data.Status : event.Status,
    //     },
    //   });
    // }

    function RowClick(event: any) {
      debugger;
      // rowFocus.value = true;
      // router.push({
      //   path: "/PODetails",
      //   query: {
      //     Id: event.data ? event.data.StockTransId : event.StockTransId,
      //   },
      // });
      visibleRight.value = false;
      //VisibleQuotesDetails.value = VisibleQuotesDetails.value === false ? true : false;
      VisibleQuotesDetails.value = true;



    }

    function Editdata(data) {
      debugger;
      POAId = data.StockTransId;
      DocType = data.DocType;
      DataEdit.value = data;
      Editmodel.value = true;
    }

    function Deletedata(data) {
      let permissionResult: any = checkPermission(Rights, "Delete");

      if (permissionResult.hasPermission) {
        DataEdit.value = data;
        POAId = data.StockTransId;
        DocType = data.DocType;
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function CloseQuoteOnClick(data) {
      debugger;

      ObjPOClosePopUp.value.PopUpHeaderName = "Close Quote Amendment";
      ObjPOClosePopUp.value.TextAareaName = "Enter Reason";
      ObjPOClosePopUp.value.ClosedReason = "";

      ObjPOClosePopUp.value.Visible = true;

      ObjPOClose.value.EntityId = data.EntityId;
      ObjPOClose.value.EntityOperationId = 3039005;
      ObjPOClose.value.DeptRoleId = rolesData.DeptRoleMapId;
      ObjPOClose.value.Id = data.StockTransId;
      ObjPOClose.value.Status = "6";
      ObjPOClose.value.IsApproved = 0;
      ObjPOClose.value.CreatedBy = usersData.UserId;
      ObjPOClose.value.BranchId = data.BranchId;
      ObjPOClose.value.HospitalId = data.HospitalId;
      ObjPOClose.value.StoreId = data.StoreId;
      ObjPOClose.value.DocNo = data.DocNo;

      ObjPOClosePopUp.value.ConfirmPopupHeader = t('confirmation.confirmclose');
      ObjPOClosePopUp.value.ConfirmPopupContent = t('confirmation.Doyouwanttoclose');
    }

    function SaveClosePO() {
      debugger;
      if (ObjPOClosePopUp.value.ClosedReason == "") {
        toast.add({
          severity: "info",
          summary: "Enter Reason",
          detail: "",
          life: 3000,
        });
      } else {
        ModelPopupDunction.value.CloseConfirmPop = true;
      }
    }

    async function UpdateCloseStatus() {
      debugger;
      try {
        ObjPOClose.value.ClosedReason = ObjPOClosePopUp.value.ClosedReason;

        const response = await commonService.UpdateCloseStatus(
          ObjPOClose.value
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          ModelPopupDunction.value.CloseConfirmPop = false;
          ModelPopupDunction.value.CloseModelTxt =
            t('confirmation.QuoteAmendmentclosedsuccessfully');
          ModelPopupDunction.value.CloseSuccessPop = true;
        } else {
          alert("Somthing went wrong");
        }
      } catch (error) {
        console.log(error);
      }
    }

    function Close() {
      ModelPopupDunction.value.CloseSuccessPop = false;
      router.back();
    }

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.Id;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };
    let actioneQuoteAmendment = ref(false);
    let actioneEdit = ref(false);
    let CancelQuote = ref(false);

    const toggle = (event, data) => {
      console.log(event);
      debugger;
      ItemStockTransId.value = data.RefId;
      objectdata = data;
      ObjData.value = data;
      QuoteId.value = data.StockTransId;
      LineDoctype.value = data.DocType;

      menu.value.toggle(event);
      // Activevisible.value = data.Status == 0 && data.IsDraft == 0 ? true : false;
      // IsPending.value = data.Status == 0 && data.IsApproved == '1' ? true : false;
      // IsPending.value =
      //   data.Status == 0 && data.IsApproved == "1" ? true : false;
      actioneQuoteAmendment.value = (data.IsApproved == 1 && data.Status == 0 && data.IsDraft != 1) ? true : false;
      actioneEdit.value = data.Status == 0 && data.IsApproved != 1 && data.IsConsigneeItem == 0 || data.IsDraft == 1 ? true : false;
      IsPending.value = (((data.Status == '0' || data.Status == '3') && data.IsDraft != '1') && data.IsApproved == '1') ? true : false;
      // CancelQuote.value = data.Status == 0 && data.IsApproved == 1 && (data.DocType == "4" || data.DocType == "5") ? true : false;
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Create new Quote Amendment",
            icon: "editicon pi pi-pencil",
            visible: actioneQuoteAmendment,
            command: async () => {
              datapass();
            },
          },
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: actioneEdit,
            command: async () => {
              Editdata(objectdata);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: actioneEdit,
            command: async () => {
              Deletedata(objectdata);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            visible: true,
            command: async () => {
              Print(objectdata);
            },
          },
          {
            label: "Close",
            icon: "deleteicon pi pi-times",
            visible: IsPending,
            command: async () => {
              CloseQuoteOnClick(objectdata);
            },
          },
        ],
      },
    ]);

    let filterItems = ref({
      Date: "",
      SupplierName: "",
      SupplierId: "",
      Code: "",
      PoCode: "",
      StatusName: "",
      StatusIds: "",
    });

    let emitedfilterItems = ref({
      SupplierName: "",
      SupplierId: "",
      Code: "",
      PoCode: "",
      StatusName: "",
      StatusIds: "",
    });

    const removechipvalue = ref(0);

    const EmitSupplierName = (data) => {
      emitedfilterItems.value.SupplierName = data;
    };

    const EmitSupplierId = (data) => {
      emitedfilterItems.value.SupplierId = data;
    };

    const Emitcode = (data) => {
      emitedfilterItems.value.Code = data;
    };

    const EmitPoCode = (data) => {
      emitedfilterItems.value.PoCode = data;
    };
    const EmitStatus = (data) => {
      emitedfilterItems.value.StatusName = data;
    };

    const EmitStatusId = (data) => {
      emitedfilterItems.value.StatusIds = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }
      filterItems.value.SupplierName = emitedfilterItems.value.SupplierName;
      filterItems.value.SupplierId = emitedfilterItems.value.SupplierId;
      filterItems.value.Code = emitedfilterItems.value.Code;
      filterItems.value.StatusIds = emitedfilterItems.value.StatusIds;
      // alert(emitedfilterItems.value.StatusIds);
      filterItems.value.StatusName = emitedfilterItems.value.StatusName;

      filterItems.value.PoCode = emitedfilterItems.value.PoCode;

      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      StorebranchmapId = routes.query.storebranchmapid ?? 0;

      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 3;
      filterItems.value.SupplierId = "";
      filterItems.value.StatusIds = "";
      filterItems.value.StatusName = "";
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      IsShow();
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      StorebranchmapId = routes.query.storebranchmapid ?? 0;

      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }

    const removeChip = (data) => {
      debugger;
      StorebranchmapId = routes.query.storebranchmapid ?? 0;

      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "Code") {
        removechipvalue.value = 1;
      } else if (data == "SupplierName") {
        filterItems.value.SupplierId = "";
        removechipvalue.value = 2;
      } else if (data == "PoCode") {
        filterItems.value.SupplierId = "";
        removechipvalue.value = 4;
      } else if (data == "StatusName") {
        filterItems.value.StatusIds = "";
        removechipvalue.value = 3;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      IsShow();
    };

    const waitingtime = (targetDate) => {
      const currentDate = new Date().getTime(); // Convert Date to number (timestamp)
      const targetDateTime = new Date(targetDate).getTime(); // Convert Date to number (timestamp)
      const differenceInTime = Math.abs(currentDate - targetDateTime);

      const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
      const differenceInMonths = Math.floor(differenceInDays / 30);
      const differenceInYears = Math.floor(differenceInDays / 365);

      const years = differenceInYears > 0 ? `${differenceInYears} Year${differenceInYears > 1 ? 's' : ''}` : '';
      const months = differenceInMonths % 12 > 0 ? `${differenceInMonths % 12} Month${differenceInMonths % 12 > 1 ? 's' : ''}` : '';
      const days = differenceInDays % 30 > 0 ? `${differenceInDays % 30} Day${differenceInDays % 30 > 1 ? 's' : ''}` : '';

      // If the difference is exactly 0 days, return "0 days"
      if (differenceInDays === 0) {
        return "0 Day";
      }

      return `${years} ${months} ${days}`.trim();
    };
    const filterStatus = [
      { id: 10, name: "All" },
      { id: 0, name: "Pending" },
      // { id: 1, name: "Converted to Quote Ammendment" },
      // { id: 2, name: "Converted to GRN" },
    ];
    const selectedStatus = ref(10);
    let buttonFilter = ref({
      Id: 0,
      Name: "",
    });
    const selectStatus = (id, name) => {
      debugger;
      selectedStatus.value = id;
      buttonFilter.value.Id = id;
      buttonFilter.value.Name = name;
      StorebranchmapId = routes.query.storebranchmapid ?? 0;

      if (id != 10) {
        StatusFilter.value.Status = false;
      } else {
        StatusFilter.value.Status = true;
      }
      IsShow();
    };

    return {
      QueryStringValue4,
      VisibleQuotesDetails,
      visibleRight,
      itemListed,
      filterStatus,
      menu,
      selectedStatus,
      selectStatus,
      toggle,
      rowsCount,
      state,
      Editdata,
      Deletedata,
      RowClick,
      Deletemodel,
      deletepop,
      Editmodel,
      headers,
      items,
      IsShow,
      IsDelete,
      generic,
      loading1,
      globalFilterFields,
      filters,
      StatusFilter,
      IsCreate,
      IsEdit,
      loading,
      SearchBox,
      SearchValue,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      FilterLoading,
      EmitSupplierName,
      EmitSupplierId,
      Emitcode,
      EmitPoCode,
      filterItems,
      removeChip,
      removechipvalue,
      hasData,
      ShowRows,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      windowWidth,
      ParameterValues,
      PrintType,
      CrystalReportPopup,
      hidepopup,
      visible,
      waitingtime,
      EmitStatus,
      EmitStatusId,

      ObjPOClosePopUp,
      SaveClosePO,
      ModelPopupDunction,
      Close,
      UpdateCloseStatus,
    };
  },
});
</script>

<style lang="scss" scoped>
.container {
  background-color: #f8f9fe;
  opacity: 1;

  .content {
    padding-top: 20px;
    margin-left: 100px;
    margin-right: 100px;

    .search {
      margin-top: 20px;
      margin-bottom: 10px;
      color: #999999;
      text-align: left;
      font: normal normal normal 14px/16px Roboto;
      letter-spacing: 0px;
      display: flex;
      justify-content: space-between;

      .filter {
        display: flex;
        align-items: center;

        .add {
          border-radius: 5px;
          margin-left: 1%;
          margin-right: 1%;
        }

        .filter-icon {
          margin-left: 10px;
          margin-right: 5px;
          border-radius: 8px;
          color: #918291;
          padding: 10px;
        }
      }
    }
  }
}
</style>